import { useClientConfigProvider } from "@/app/config/client-config-provider";
import Image from "next/image";
import { useTranslation } from "react-i18next";
import { Modal, ModalBody } from "reactstrap";

function ActivatedMembershipModal({ show = false }: { show: boolean }) {
  const { getImagePath } = useClientConfigProvider();
  const { t } = useTranslation();

  return (
    <Modal isOpen={show} centered zIndex={""}>
      <ModalBody className="activated-membership-modal-container">
        <div className="activated-membership-modal-wall">
          <div className="success-lottie">
            <Image
              src={getImagePath("success-anim.gif")}
              layout="fill"
              alt={""}
              style={{
                width: "100%",
                height: "100%",
                objectFit: "contain",
              }}
            />
          </div>

          <div className="success-membership-container">
            <Image
              src={getImagePath("activated-membership-success.gif")}
              alt={""}
              height={100}
              width={100}
            />
          </div>

          <div className="congrats_heading">
            {t("redeemSuccess.congratulations")}
          </div>
          <div className="congrats_lbl_text">
            {t("linkMembership.activatedMembershipSuccessMsg")}
          </div>
        </div>
      </ModalBody>
    </Modal>
  );
}
export default ActivatedMembershipModal;
